import type {Pointer} from '@wix/document-services-types'
import {DATA_TYPES} from '../../../constants/constants'
import type {RefOverridesAPI} from '../../refOverrides'

export class RefComponentRepository {
    constructor(private readonly refOverrides: RefOverridesAPI) {}

    getDataOverride(refCompPointer: Pointer, innerComponentPointer: Pointer) {
        const refComponentData = this.refOverrides.getOverride(
            refCompPointer.id,
            [innerComponentPointer.id],
            DATA_TYPES.data
        )
        return refComponentData
    }

    getStyleOverride(refCompPointer: Pointer, innerComponentPointer: Pointer) {
        const refComponentData = this.refOverrides.getOverride(
            refCompPointer.id,
            [innerComponentPointer.id],
            DATA_TYPES.theme
        )
        return refComponentData
    }
}
